module.exports = __webpack_public_path__ + "img/ic_pin_set.9efe2ef9.svg";